import Vue from 'vue';
import Router from 'vue-router';
import NewsList from './views/news/NewsList.vue';
import NewsEdit from './views/news/NewsEdit.vue';
import Login from './views/login/Login.vue';
// eslint-disable-next-line import/extensions
import tab from './views/tabs';
import industryEdit from './views/Industry/IndustryEdit.vue';

Vue.use(Router);
export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
    },
    {
      path: '/newsList',
      name: 'newsList',
      component: NewsList,
    }, {
      path: '/tab',
      name: 'tab',
      component: tab,
    },
    {
      path: '/newsEdit',
      name: 'newsEdit',
      component: NewsEdit,
    },
    {
      path: '/industryEdit',
      name: 'industryEdit',
      component: industryEdit,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
  ],
});
